import { createFileRoute, redirect } from '@tanstack/react-router'
import { CreditCostsPage } from '@/pages/Credits/CreditCostsPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/credit-costs')({
  component: CreditCostsPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/credit-costs')) {
      throw redirect({ to: '/' })
    }
  },
})
